import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import AdminContextProvider from './context/AdminContext';
import UserContextProvider from './context/UserContext';
import ProductContextProvider from './context/ProductContext';
import ReportesContextProvider from './context/ReportesContext';
import PedidosContextProvider from './context/PedidosContext';
import { AxiosInterceptor } from './extras/Axios';
import { BrowserRouter as Router } from "react-router-dom";

ReactDOM.render(
  <React.StrictMode>
    <Router forceRefresh={true}>
    <AdminContextProvider>
      <AxiosInterceptor>
        <ReportesContextProvider>
          <ProductContextProvider>
            <UserContextProvider>  
                <PedidosContextProvider>
                  <App />
                </PedidosContextProvider>
            </UserContextProvider>
          </ProductContextProvider>
        </ReportesContextProvider>
      </AxiosInterceptor>
    </AdminContextProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
